export default __webpack_public_path__ + "static/media/om.8ce9655c.svg";